import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import AddPatient from '../../../components/Patients/Add/PatientAdd';
import { addPatient } from '../../../actions/entities';

const mapDispatchToProps = dispatch => ({
  submitAction: patient => dispatch(addPatient(patient)),
  navigate: url => dispatch(push(url)),
  goBack: () => dispatch(goBack()),
});

const EditPatientContainer = connect(
  null,
  mapDispatchToProps,
)(AddPatient);

export default EditPatientContainer;
